import { initialCommonState, actions } from "./action";

const dataFormatter = (payload) => {
    const formattedData = [];
    if(Array.isArray(payload)) {
        const propValue = payload[0].propValue;
        const entries = Object.entries(propValue);
        entries.forEach(([key, Label]) => {
            formattedData.push({ 
                label: Label, 
                value: key
            })
        });
    }
    return formattedData;
}

export const commonReducer = (state = initialCommonState, action) => {
    let formattedData = []
    switch (action.type) {
        case actions.PRIORITY_GET_ALL_SUCCESS:
            formattedData = dataFormatter(action.payload?.data);
            return {
                ...state,
                priorityList: formattedData
            };
        case actions.PRIORITY_GET_ALL_FAILURE:
            return {
                ...state,
                priorityList: []
            };
        case actions.PRIORITY_RESET_SUCCESS:
            return {
                ...state,
                priorityList: []
            };
        // case actions.TIMEZONE_GET_ALL_SUCCESS:
        //     formattedData = dataFormatter(action.payload?.data);
        //     return {
        //         ...state,
        //         timeZoneList: formattedData?.map( data =>{
        //             return `${data.value} : ${data.label}`
        //         })
        //     };
        // case actions.TIMEZONE_GET_ALL_FAILURE:
        //     return {
        //         ...state,
        //         timeZoneList: []
        //     };
        // case actions.TIMEZONE_RESET_SUCCESS:
        //     return {
        //         ...state,
        //         timeZoneList: []
        //     };
        case actions.TASKTYPE_GET_ALL_SUCCESS:
            formattedData = dataFormatter(action.payload?.data);
            return {
                ...state,
                taskTypeList: formattedData
            };
        case actions.TASKTYPE_GET_ALL_FAILURE:
            return {
                ...state,
                taskTypeList: []
            };
        case actions.TASKTYPE_RESET_SUCCESS:
            return {
                ...state,
                taskTypeList: []
            };
        case actions.REPEAT_GET_ALL_SUCCESS:
            formattedData = dataFormatter(action.payload?.data);
            return {
                ...state,
                repeatList: formattedData
            };
        case actions.REPEAT_GET_ALL_FAILURE:
            return {
                ...state,
                repeatList: []
            };
        case actions.REPEAT_RESET_SUCCESS:
            return {
                ...state,
                repeatList: []
            };
        case actions.ROLESLIST_GET_ALL_SUCCESS:
            formattedData = dataFormatter(action.payload?.data);
            return {
                ...state,
                rolesList: formattedData
            };
        case actions.ROLESLIST_GET_ALL_FAILURE:
            return {
                ...state,
                rolesList: []
            };
        case actions.ROLESLIST_RESET_SUCCESS:
            return {
                ...state,
                rolesList: []
            };
        case actions.PROGRESS_GET_ALL_SUCCESS:
            formattedData = dataFormatter(action.payload?.data);
            return {
                ...state,
                progressList: formattedData
                };
        case actions.PROGRESS_GET_ALL_FAILURE:
            return {
                ...state,
                progressList: []
            };
        case actions.PROGRESS_RESET_SUCCESS:
            return {
                ...state,
                progressList: []
            };
        case actions.STORE_GET_ALL_SUCCESS:
            formattedData = [];
            if(Array.isArray(action.payload?.data)) {
                const payload = action.payload?.data;
                formattedData = payload.map(item => ({ 
                    ...item,
                    label: `${item.siteId} - ${item.title}`, 
                    value: item.siteId
                }));
            }
            return {
                ...state,
                storeList: formattedData
            };
        case actions.STORE_GET_ALL_FAILURE:
            return {
                ...state,
                storeList: []
            };
        case actions.STORE_RESET_SUCCESS:
            return {
                ...state,
                storeList: []
            };
        case actions.SITEGROUPLIST_GET_ALL_SUCCESS:
            formattedData = [];
            if(Array.isArray(action.payload?.data)) {
                const payload = action.payload?.data;
                formattedData = payload
                .filter(item => item.status === "Active")
                .map(item => ({ 
                    ...item,
                    label: `${item.groupName}`, 
                    value: item.groupCode
                }));
            }
            return {
                ...state,
                siteGroupList: formattedData
            };
        case actions.SITEGROUPLIST_GET_ALL_FAILURE:
            return {
                ...state,
                siteGroupList: []
            };
        case actions.SITEGROUPLIST_RESET_SUCCESS:
            return {
                ...state,
                siteGroupList: []
            };
        case actions.USERLIST_GET_ALL_SUCCESS:
            formattedData = [];
            if(Array.isArray(action.payload.data)) {
                const payload = action.payload.data;
                formattedData = payload.map(item => ({
                    ...item,
                    label: `${item.firstName} ${item.lastName} (${item.userId})`, 
                    value: item.userId,
                }))
            }
            return {
                ...state,
                userList: formattedData
            };
        case actions.USERLIST_GET_ALL_FAILURE:
            return {
                ...state,
                userList: []
            };
        case actions.USERLIST_RESET_SUCCESS:
            return {
                ...state,
                userList: []
            };
        case actions.REMINDER_GET_ALL_SUCCESS:
            formattedData = dataFormatter(action.payload.data);
            return {
                ...state,
                reminderList: formattedData
            };
        case actions.REMINDER_GET_ALL_FAILURE:
            return {
                ...state,
                reminderList: []
            };
        case actions.REMINDER_RESET_SUCCESS:
            return {
                ...state,
                reminderList: []
            };
        default:
            return state;
    }
};
